import ApiService from '@/lib/api';
import BlogList from '@/components/Blog/BlogList';
import { GetStaticProps } from 'next';
import MainLayout from '../../layouts/MainLayout';
import { withSiteName } from '@/utils/pageTitle';

export const getStaticProps: GetStaticProps = async () => {
  const postsPerPage = 6;
  const currentPage = 0;
  const apiService = new ApiService();
  const [data, blogsLength, menuData, miscData] = await Promise.all([
    apiService.getBlogPostsList(currentPage, postsPerPage - 1),
    apiService.getBlogPostsLength(),
    apiService.getMenuData(),
    apiService.getMiscData(),
  ]);
  const numPages = Math.ceil(blogsLength / postsPerPage);
  const { blogList, footer } = miscData;

  return {
    props: {
      posts: data,
      blogList,
      currentPage,
      numPages,
      menuData,
      footer,
    },
    revalidate: 3600,
  };
};

const CulturePage = ({ posts, currentPage, numPages, blogList, menuData, footer }) => {
  return (
    <MainLayout
      bgWhite={false}
      navIsFixed={false}
      navIsDark={false}
      ogUrl="https://foxbox.com/blog"
      metaTitle={blogList?.blogListMetaTitle || withSiteName(blogList?.heading)}
      footer={footer}
      menuData={menuData}
      metaDescription={blogList?.blogListMetaDescription}
      noMargin
    >
      <BlogList posts={posts} numPages={numPages} currentPage={currentPage + 1} blogListCopy={blogList} />
    </MainLayout>
  );
};

export default CulturePage;
